export const isAmppa = process.env.REACT_APP_IS_AMPPA === "1";